import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import store from './store'

import authHandler from './authHandler';
import sessionManager from './sessionManager';

const app = createApp(App);

// Use a relative base so API requests are same-origin. In dev, Vite proxies
// /api to the backend (see vite.config.js); in prod, nginx proxies /api.
// This keeps the session cookie first-party so browsers send it on every request.
app.config.globalProperties.$BACKEND_HOST = '';

app.config.warnHandler = () => {};

app.use(router);
app.use(store);
app.use(authHandler);

store.dispatch('checkAuth');

app.mount('#app')

